import React from 'react';

class NationalReportsListCount extends React.Component {
  render() {
    if (!this.props.list || !Array.isArray(this.props.list)) return null;

    const count = this.props.list.length;
    let phrase;


    if (count === 1) {
      phrase = '1 report found.'
    } else {
      phrase = `${count} reports found`;
    }

    return (
      <p>{ phrase }</p>
    )
  }
}

export default NationalReportsListCount;



// WEBPACK FOOTER //
// ./src/components/NationalReports/NationalReportsListCount.js